<template>
    <div>
        <!-- 查看弹框-->
        <el-form
            :model="lookform"
            ref="lookform"
            :rules="rules"
            label-width="180px"
        >
            <el-form-item label="服务主题：">
                <el-input
                    v-model="lookform.activityTheme"
                    class="form_input"
                    :disabled="readonly"
                    placeholder="请输入"
                ></el-input>
            </el-form-item>
            <el-form-item label="主办单位：">
                <el-input
                    v-model="lookform.organizer"
                    class="form_input"
                    :disabled="readonly"
                    placeholder="请输入"
                ></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="phone">
                <el-input
                    v-model="lookform.phone"
                    class="form_input2"
                    placeholder="请输入"
                    :disabled="readonly"
                    autocomplete="off"
                ></el-input>
                <span class="yihang"> 联系人：</span>
                <el-input
                    v-model="lookform.contacts"
                    class="form_input2"
                    placeholder="请输入"
                    :disabled="readonly"
                    autocomplete="off"
                ></el-input>
            </el-form-item>
            <el-form-item label="报名截止时间：">
                <el-date-picker
                    :disabled="readonly"
                    v-model="lookform.signUpTimes"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"
                    style="width: 250px"
                    placeholder="选择日期"
                ></el-date-picker>
                <span class="yihang">上限人数：</span>
                <el-input
                    v-model="lookform.upperLimit"
                    class="form_input2"
                    type="number"
                    :disabled="readonly"
                    placeholder="请输入"
                    autocomplete="off"
                ></el-input>
            </el-form-item>
            <el-form-item label="所属社会组织：">
                <el-select
                    class="form_input2"
                    :disabled="readonly"
                    v-model="lookform.socialOrgId"
                    placeholder="请选择"
                >
                    <el-option
                        v-for="item in socialOrgOptions"
                        :key="item.id"
                        :label="item.orgName"
                        :value="item.id"
                    ></el-option>
                </el-select>
                <span class="yihang">招募对象：</span>
                <el-select
                    class="form_input2"
                    :disabled="readonly"
                    v-model="lookform.recruitObject"
                    placeholder="请选择"
                >
                    <el-option label="本组织社工" value="0"></el-option>
                    <el-option label="所有社工" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="活动时间：">
                <el-date-picker
                    :disabled="readonly"
                    v-model="lookform.startActivityTime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"
                    style="width: 279px"
                    placeholder="选择开始时间"
                    :picker-options="pickerOptionsStart"
                ></el-date-picker>
                &nbsp;&nbsp;&nbsp;至&nbsp;&nbsp;
                <el-date-picker
                    :disabled="readonly"
                    v-model="lookform.endActivityTime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"
                    style="width: 279px"
                    placeholder="选择结束时间"
                    :picker-options="pickerOptionsEnd"
                ></el-date-picker>
            </el-form-item>
            <!-- <el-form-item label="招募对象：" >
          <el-select class="form_input" :disabled="readonly" v-model="lookform.recruitObject" placeholder="请选择">
            <el-option label="本组织社工" value="0" ></el-option>
            <el-option label="所有社工" value="1" ></el-option>
          </el-select>
        </el-form-item>   -->
            <el-form-item label="服务内容：">
                <el-input
                    v-model="lookform.serviceContent"
                    class="form_input"
                    :disabled="readonly"
                    autocomplete="off"
                    type="textarea"
                    :row="4"
                ></el-input>
            </el-form-item>
            <el-form-item label="服务地点：" style="margin-top: 20px">
                <div
                    class="form_input"
                    style="
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 15px;
                    "
                >
                    <el-select
                        class="addres_input"
                        :disabled="readonly"
                        v-model="lookform.province"
                        style="margin-right: 20px"
                        placeholder="请选择"
                    >
                        <el-option label="绩溪县" :value="1"></el-option>
                    </el-select>
                    <el-select
                        class="addres_input"
                        :disabled="readonly"
                        style="margin-right: 20px"
                        @change="getAddressByParentId"
                        v-model="lookform.city"
                        placeholder="请选择"
                    >
                        <el-option label="来苏社区" :value="2"></el-option>
                    </el-select>
                    <el-select
                        class="addres_input"
                        :disabled="readonly"
                        v-model="areaId"
                        @change="changeArea"
                        placeholder="选择网格"
                        style="width: 174px"
                    >
                        <el-option
                            v-for="item in gridCode"
                            :key="item.id"
                            :label="item.orgName"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </div>
                <div style="display: flex; margin-bottom: 15px">
                    <el-input
                        class="form_input"
                        :disabled="readonly"
                        v-model="lookform.address"
                        @blur="transLocation"
                    ></el-input>
                </div>
                <div style="display: flex; margin-bottom: 15px">
                    <div
                        id="container"
                        class="form_input"
                        style="height: 200px; margin-bottom: 30px"
                    ></div>
                </div>
            </el-form-item>
            <!-- <el-form-item label="服务地点：" >
          <el-input v-model="lookform.activityPlace" class="form_input" :disabled="readonly" autocomplete="off"></el-input>
        </el-form-item> -->
            <el-form-item label="发布平台：">
                <el-checkbox-group v-model="platformcheckList">
                    <el-checkbox
                        label="0"
                        class="form_input"
                        :disabled="readonly"
                        >公众号</el-checkbox
                    >
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="活动图片：">
                <el-upload
                    :disabled="readonly"
                    :action="url"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :on-success="imgok"
                    :file-list="fileListimg"
                    :on-remove="handleRemove"
                >
                    <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible" append-to-body>
                    <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
            </el-form-item>
            <div v-if="auditsend == true" style="margin-top: 30px">
                <el-form-item label="审核结果">
                    <template>
                        <el-radio
                            class="addradio"
                            v-model="lookform.approvalStatus"
                            label="1"
                            >审核通过</el-radio
                        >
                        <el-radio
                            class="addradio"
                            v-model="lookform.approvalStatus"
                            label="2"
                            >审核不通过</el-radio
                        >
                    </template>
                </el-form-item>
                <el-form-item label="审核意见">
                    <el-input
                        class="form_input"
                        v-model="lookform.approvalOpinion"
                        :autosize="{ minRows: 2 }"
                        type="textarea"
                        placeholder="审核不通过时,请填写此项"
                    ></el-input>
                </el-form-item>
            </div>
            <el-form-item>
                <div class="footer">
                    <el-button
                        v-if="addsend == true"
                        type="primary"
                        @click="addSave()"
                        >确 定</el-button
                    >
                    <el-button
                        v-if="auditsendan == true"
                        type="primary"
                        @click="shenheSave()"
                        >审核</el-button
                    >
                    <el-button
                        v-if="editsend == true"
                        type="primary"
                        @click="editSave()"
                        >修 改</el-button
                    >
                    <el-button
                        v-if="readonly != true"
                        type="info"
                        @click="clearForm()"
                        >取 消</el-button
                    >
                </div>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { post } from "@/api/requrestHttp.js"
import baseURL from "@/api/baseURL"
export default {
    props: ["rowid", "readonlys"],
    data() {
        return {
            id: this.rowid,
            readonly: this.readonlys,
            lookform: {},
            addsend: false,
            editsend: false,
            auditsend: false,
            auditsendan: false,
            // 开始日期 :picker-options 中引用
            pickerOptionsStart: {
                disabledDate: (time) => {
                    // 获取结束日期的 v-model 值并赋值给新定义的对象
                    let endDateVal = this.lookform.signUpTimes
                    if (endDateVal) {
                        // 比较 距 1970 年 1 月 1 日之间的毫秒数：
                        return time.getTime() < new Date(endDateVal)
                    }
                },
            },
            // 结束日期 :picker-options 中引用
            pickerOptionsEnd: {
                disabledDate: (time) => {
                    // 获取开始日期的 v-model 值并赋值给新定义的对象
                    let beginDateVal = this.lookform.startActivityTime
                    if (beginDateVal) {
                        // 比较 距 1970 年 1 月 1 日之间的毫秒数：
                        return time.getTime() < new Date(beginDateVal)
                    }
                },
            },
            gridCode: [],
            areaId: "",
            url:baseURL+
                "/ypt/controller/uploadVotePic/info/uploadPartyPhoto",
            lookDialogVisible: false,
            activityTimes: [],
            platformcheckList: [],
            socialOrgOptions: [],
            dialogImageUrl: "",
            dialogVisible: false,
            fileListimg: [],
            rules: {
                // name: [{ required: true, message: "请输入姓名", trigger: "blur",}],
                // sex: [{ required: true, message: "请选择性别", trigger: "blur",}],
                phone: [
                    {
                        required: true,
                        message: "请输入手机号码",
                        trigger: "blur",
                    },
                    {
                        validator: function (rule, value, callback) {
                            if (/^1[34578]\d{9}$/.test(value) == false) {
                                callback(new Error("请输入正确的手机号"))
                            } else {
                                callback()
                            }
                        },
                        trigger: "blur",
                    },
                ],
                idCode: [
                    {
                        required: true,
                        message: "请输入身份证号",
                        trigger: "blur",
                    },
                    {
                        pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                        message: "你的身份证格式不正确",
                    },
                ],
                // signUpTimes: [{ type: 'date', required: true, message: '请选择报名截止时间', trigger: 'blur' }],
            },
        }
    },
    methods: {
        //上传图片方法
        handleRemove(file, fileList) {
            console.log(this.lookform.photo)
            this.lookform.photo.map((item, index) => {
                if (file.response != undefined) {
                    if (item == file.response.content) {
                        this.lookform.photo.splice(index, 1)
                    }
                } else {
                    if (item == file.url) {
                        this.lookform.photo.splice(index, 1)
                    }
                }
            })
            console.log(this.lookform.photo)
        },
        imgok: function (data, data1, data2) {
            if (data.code == 200) {
                if (!this.lookform.photo) {
                    this.lookform.photo = []
                }
                this.lookform.photo.push(data.content)
            }
        },
        disabledDate() {
            alert(111)
            return date.getTime() <= Date.now()
            console.log(date.getTime() <= Date.now())
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url
            this.dialogVisible = true
        },
        //根据输入地址转换经纬度并标记
        transLocation() {
            var searchKey = this.lookform.address
            var map = new AMap.Map("container", {
                resizeEnable: true,
                zoom: 18,
            })
            var that = this
            AMap.plugin("AMap.Geocoder", function () {
                var geocoder = new AMap.Geocoder({
                    radius: 1000,
                    extensions: "all",
                })
                var marker = new AMap.Marker()
                geocoder.getLocation(searchKey, function (status, result) {
                    if (status === "complete" && result.geocodes.length) {
                        var lnglat = result.geocodes[0].location
                        that.lookform.longitude = String(lnglat.lng)
                        that.lookform.latitude = String(lnglat.lat)
                        console.log("that.lookform=>", that.lookform)
                        marker.setPosition(lnglat)
                        map.add(marker)
                        map.setFitView(marker)
                    } else {
                        that.$message({
                            message: "获取坐标失败，请手动获取",
                            type: "error",
                        })
                        that.mapInit("container")
                    }
                })
                map.on("click", function (e) {
                    that.lookform.longitude = String(e.lnglat.getLng())
                    that.lookform.latitude = String(e.lnglat.getLat())
                    geocoder.getAddress(
                        e.lnglat.getLng() + "," + e.lnglat.getLat(),
                        function (status, result) {
                            console.log(status)
                            if (status === "complete" && result.regeocode) {
                                var address = result.regeocode.formattedAddress
                                that.$set(that.lookform, "address", address)
                            } else {
                                log.error("根据经纬度查询地址失败")
                            }
                        }
                    )
                })
            })
        },
        //初始化地图插件的方法
        mapInit(containerId) {
            console.log("containerId", containerId)
            var map = new AMap.Map(containerId, {
                resizeEnable: true,
                zoom: 18,
                zooms: [3, 20],
                expandZoomRange: true,
                center: [118.009229, 32.790228],
            })
            console.log(map)
            if (this.lookform.longitude && this.lookform.latitude) {
                var marker = new AMap.Marker({
                    position: [
                        Number(this.lookform.longitude),
                        Number(this.lookform.latitude),
                    ],
                    map: map,
                })
                map.setFitView(marker)
            } else {
                AMap.plugin("AMap.Geolocation", function () {
                    //异步定位当前
                    var geolocation = new AMap.Geolocation()
                    map.addControl(geolocation)
                })
            } //定义地图坐标点击事件
            var that = this
            var geocoder = new AMap.Geocoder({
                city: "010", //城市设为北京，默认：“全国”
                radius: 1000, //范围，默认：500
            })
            map.on("click", function (e) {
                console.log(
                    56565,
                    that.lookform.longitude,
                    that.lookform.longitude
                )
                that.lookform.longitude = String(e.lnglat.getLng())
                that.lookform.latitude = String(e.lnglat.getLat())
                geocoder.getAddress(
                    e.lnglat.getLng() + "," + e.lnglat.getLat(),
                    function (status, result) {
                        console.log(status)
                        if (status === "complete" && result.regeocode) {
                            var address = result.regeocode.formattedAddress
                            that.$set(that.lookform, "address", address)
                        } else {
                            log.error("根据经纬度查询地址失败")
                        }
                    }
                )
            })
        },
        changeArea(val) {
            console.log(val)
            this.lookform.area = val
            console.log("this.lookform.area", this.lookform.area)
        },
        // 获取地址下拉
        getAddressByParentId(addId) {
            this.gridCode = []
            this.areaId = ""
            post("/admin/org/info/findOrgGrid", {
                parentId: "2",
            }).then((res) => {
                console.log(res.content)
                this.gridCode = res.content.list
            })
        },
        // 审核保存
        shenheSave() {
            post("/admin/serviceItems/info/updateServiceItems", {
                id: this.id,
                approvalStatus: this.shenheform.approvalStatus,
                approvalOpinion: this.shenheform.approvalOpinion,
            }).then((res) => {
                if (res.code == 200) {
                    this.$message({ message: "审核成功", type: "success" })
                    this.dialogFormVisibleTwo = false
                    this.clearForm()
                } else {
                    this.$message({ message: "审核失败", type: "error" })
                }
            })
        },
        // 修改保存
        editSave(id) {
            this.$refs.lookform.validate((valid) => {
                if (valid) {
                    this.platformcheckList = this.platformcheckList + ""
                    this.lookform.publishPlatform = this.platformcheckList
                    //循环拼接
                    var str = ""
                    if (Array.isArray(this.lookform.photo)) {
                        this.lookform.photo.map((item, index) => {
                            str += item + "#"
                        })
                    } else {
                        str = this.lookform.photo
                    }
                    this.$set(this.lookform, "photo", str)
                    console.log(this.lookform)
                    post("/admin/serviceItems/info/updateServiceItems", {
                        id: this.id,
                        ...this.editform,
                    }).then((res) => {
                        if (res.code == 200) {
                            this.$message({
                                message: "修改成功",
                                type: "success",
                            })
                            this.dialogFormVisibleTwo = false
                            this.clearForm()
                        } else {
                            this.$message({
                                message: "修改失败",
                                type: "error",
                            })
                        }
                    })
                }
            })
        },
        // 新增保存
        addSave() {
            this.$refs.lookform.validate((valid) => {
                if (valid) {
                    console.log(this.platformcheckList)
                    this.platformcheckList = this.platformcheckList + ""
                    this.lookform.publishPlatform = this.platformcheckList
                    //循环拼接
                    var str = ""
                    if (Array.isArray(this.lookform.photo)) {
                        this.lookform.photo.map((item, index) => {
                            str += item + "#"
                        })
                    } else {
                        str = this.lookform.photo
                    }
                    this.$set(this.lookform, "photo", str)
                    console.log(this.lookform)
                    post("/admin/serviceItems/info/insertServiceItems", {
                        ...this.lookform,
                        approvalStatus: 0,
                    }).then((res) => {
                        if (res.code == 200) {
                            this.$message({
                                message: "新增成功",
                                type: "success",
                            })
                            this.dialogFormVisibleTwo = false
                            this.clearForm()
                        } else {
                            this.$message({
                                message: "新增失败",
                                type: "error",
                            })
                        }
                    })
                }
            })
        },
        // 获取社会组织
        getSocialOrg() {
            post("/admin/socialOrg/info/listSocialOrg", {
                pageNo: 1,
                pageSize: 999,
            }).then((res) => {
                console.log(res)
                this.socialOrgOptions = res.content.list
            })
        },
        clearForm() {
            this.lookform = {}
            this.lookform.longitude = ""
            this.lookform.latitude = ""
            this.$emit("close")
        },
        closeLookProject() {
            this.showcheck = false
        },
        getData() {
            console.log("getData")
            this.lookform = {}
            this.activityTimes = []
            this.platformcheckList = []
            this.fileListimg = []
            this.getSocialOrg()
            this.getAddressByParentId(2)
        },
        getDetail() {
            console.log("getDetail", this.id, this.readonly)
            this.activityTimes = []
            this.lookform.photo = []
            this.lookDialogVisible = true
            if (this.id) {
                post("/admin/serviceItems/info/getServiceItems", {
                    id: this.id,
                }).then((res) => {
                    this.lookform = res.content
                    this.areaId = res.content.area
                    if (
                        res.content.startActivityTime !== null &&
                        res.content.startActivityTime !== null
                    ) {
                        this.activityTimes.push(res.content.startActivityTime)
                        this.activityTimes.push(res.content.endActivityTime)
                    }
                    this.platformcheckList = res.content.publishPlatform.split(
                        ","
                    )
                    if (this.lookform.photo) {
                        this.lookform.photo = res.content.photo.split("#")
                        this.lookform.photo.map((item1, index) => {
                            if (item1 == "") {
                                this.lookform.photo.splice(index, 1)
                            }
                        })
                        console.log(this.lookform.photo)
                        this.lookform.photo.map((item) => {
                            this.fileListimg.push({
                                url: item,
                            })
                        })
                    }
                    console.log("lookform", this.lookform)
                })
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    this.mapInit("container")
                }, 500)
            })
        },
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.mapInit("container")
            }, 500)
        })
    },
}
</script>

<style lang="less">
.form_input {
    width: 600px;
}
.el-form-item {
    margin-top: 20px;
}
.footer {
    text-align: center;
    margin-left: -140px;
}
.yihang {
    margin-left: 30px;
}
.form_input2 {
    width: 248px;
}
</style>